import { render, staticRenderFns } from "./order-boat-form.vue?vue&type=template&id=73a8f689&"
import script from "./order-boat-form.vue?vue&type=script&lang=js&"
export * from "./order-boat-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports